
import { useEffect, useState } from 'react';
import { recordStoryView } from '@/services/analyticsService';
import { useAuth } from '@/contexts/auth';

export function useRecordStoryView(storyId: string | undefined) {
  const [hasRecorded, setHasRecorded] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    // Only record the view once per session for this story
    if (!storyId || hasRecorded) return;
    
    const sessionKey = `story-view-${storyId}`;
    const hasViewedInSession = sessionStorage.getItem(sessionKey);
    
    if (!hasViewedInSession) {
      recordStoryView(storyId, user?.id)
        .then(() => {
          sessionStorage.setItem(sessionKey, 'true');
          setHasRecorded(true);
        })
        .catch(error => {
          console.error('Failed to record story view:', error);
        });
    } else {
      setHasRecorded(true);
    }
  }, [storyId, hasRecorded, user]);

  return hasRecorded;
}
